import { InvoiceActionMenuInvoice } from '../InvoiceActionMenu';

type InvoicePrinter = (invoice: InvoiceActionMenuInvoice) => void;

let printer: InvoicePrinter | null = null;

export const registerInvoicePrinter = (fn: InvoicePrinter | null): void => {
  printer = fn;
};

export const printInvoiceViaBridge = (
  invoice: InvoiceActionMenuInvoice
): void => {
  printer?.(invoice);
};
